import { render } from "./ProdBtn02.vue?vue&type=template&id=41012054&scoped=true"
import script from "./ProdBtn02.vue?vue&type=script&lang=js"
export * from "./ProdBtn02.vue?vue&type=script&lang=js"

import "./ProdBtn02.vue?vue&type=style&index=0&id=41012054&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41012054"]])

export default __exports__